module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey-white"
  }, [_c('div', {
    staticClass: "mt-70 px-5"
  }, [_c('div', {
    staticClass: "font-poppins font-weight-600 mb-4"
  }, [_vm._v("FEATURE")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Sign Ups\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": "",
      "input-value": _vm.settings.disable_sign_up
    },
    on: {
      "change": function($event) {
        _vm.updateSetting('disable_sign_up')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Login\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.login),
      callback: function($$v) {
        _vm.$set(_vm.settings, "login", $$v)
      },
      expression: "settings.login"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Verification\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": "",
      "input-value": _vm.settings.disable_verification
    },
    on: {
      "change": function($event) {
        _vm.updateSetting('disable_verification')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Live Video\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": "",
      "input-value": _vm.settings.disable_live_video
    },
    on: {
      "change": function($event) {
        _vm.updateSetting('disable_live_video')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Uploads\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.uploads),
      callback: function($$v) {
        _vm.$set(_vm.settings, "uploads", $$v)
      },
      expression: "settings.uploads"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Product Uploads\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.merch_uploads),
      callback: function($$v) {
        _vm.$set(_vm.settings, "merch_uploads", $$v)
      },
      expression: "settings.merch_uploads"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Site For Maintenance\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.maintenance),
      callback: function($$v) {
        _vm.$set(_vm.settings, "maintenance", $$v)
      },
      expression: "settings.maintenance"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-white pa-3 rounded-10px"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Send All Users Direct Message\n      ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "w-100 message font-poppins rounded-10px pa-2",
    attrs: {
      "placeholder": "Write a message to all users"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "bg-blue-1 text-white rounded-20",
    nativeOn: {
      "click": function($event) {
        _vm.sendGlobalMessage()
      }
    }
  }, [_vm._v("\n        Send\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6553a1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/settings.vue
// module id = 1737
// module chunks = 180